import React, { useState, useEffect, useRef, useLayoutEffect, useMemo } from 'react';
import { Dialog, DialogTitle, Grid, IconButton, LinearProgress, Typography, useTheme } from '@mui/material';
import { Box, keyframes } from '@mui/system';
import { ArrowBack } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import CustomDialogBox from '../../../common/CustomDialogBox';
import NewsDetailsNavbar from './NewsDetailsNavbar';
import NewsComments from './NewsComments';
import ReferralForm from './ReferralForm';
import { useSelector } from 'react-redux';
import { selectTwinWinForm } from '../gnnSlice';

const swipeLeftAnimation = keyframes`
  0% { transform: translateX(0); }
  100% { transform: translateX(-100%); }
`;

const swipeRightAnimation = keyframes`
  0% { transform: translateX(0); }
  100% { transform: translateX(100%); }
`;

function SwipeableGrid({
  isSm,
  handleSwipeLeft,
  handleSwipeRight,
  handleSwipeUp,
  storyLength,
  // handleSwipeDown,
  carouselName,
  carouselIcon,
  topNews,
  trendingNews,
  children,
  currentIndex,
  setCurrentIndex,
  iterableData,
  isLoading,
}) {
  // const storyLength = useMemo(() => {
  //   return carouselName === 'Featured' ? topNews?.length - 1 : trendingNews?.length - 1;
  // }, [carouselName, topNews, trendingNews]);
  const [touchStartX, setTouchStartX] = useState(null);
  const [touchStartY, setTouchStartY] = useState(null);
  const [swipeDirection, setSwipeDirection] = useState(null);
  // const [activeProgressIndex, setActiveProgressIndex] = useState(0);
  const dataLength = (iterableData?.length ?? 0) - 1;
  // const [progressValues, setProgressValues] = useState(Array.from({ length: storyLength + 1 }).fill(0));
  const [progressValues, setProgressValues] = useState(Array.from({ length: dataLength + 1 }).fill(0));
  const [isPaused, setIsPaused] = useState(false);
  const containerRef = useRef(null);
  const navigate = useNavigate();
  const theme = useTheme();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [selectedNewsId, setSelectedNewsId] = useState('');
  const isTwinWinFormOpen = useSelector(selectTwinWinForm);

  useEffect(() => {
    if (swipeDirection === 'left') {
      containerRef.current.style.animation = `${swipeLeftAnimation} 0.5s forwards`;
    } else if (swipeDirection === 'right') {
      containerRef.current.style.animation = `${swipeRightAnimation} 0.5s forwards`;
    }
  }, [swipeDirection]);

  useEffect(() => {
    function handleStoryClose(event) {
      const message = event.data;
      if (message.type === 'closeStory') {
        // handleCloseCarousel()
        handleSwipeUp();
        console.log('into the closeStory');
      }
    }
    window.addEventListener('message', handleStoryClose);
  }, []);

  useEffect(() => {
    if(isTwinWinFormOpen){      
      setDialogOpen(true)

    }else{
      setDialogOpen(false)
    }
  },[isTwinWinFormOpen])

  const handleTouchStart = (e) => {
    setTouchStartX(e.touches[0].clientX);
    setTouchStartY(e.touches[0].clientY);
    setIsPaused(true); // Pause progress on touch start
  };

  const handleTouchEnd = () => {
    setIsPaused(false); // Resume progress on touch end
  };

  const handleTouchMove = (e) => {
    if (touchStartX === null || touchStartY === null) return;

    const touchEndX = e.touches[0].clientX;
    const touchEndY = e.touches[0].clientY;
    const distanceX = touchStartX - touchEndX;
    const distanceY = touchStartY - touchEndY;

    if (Math.abs(distanceX) > Math.abs(distanceY)) {
      // Horizontal swipe
      if (Math.abs(distanceX) > 50) {
        setSwipeDirection(distanceX > 0 ? 'left' : 'right');
        if (distanceX > 0) {
          // Swipe left
          if (typeof handleSwipeRight === 'function') {
            handleSwipeRight();
          }
        } else {
          // Swipe right

          if (typeof handleSwipeLeft === 'function') {
            handleSwipeLeft();
          }
        }
        setTouchStartX(null); // Reset touch start position
        setTouchStartY(null); // Reset touch start position
      }
    } else {
      // Vertical swipe
      if (Math.abs(distanceY) > 50) {
        if (distanceY > 0) {
          // Swipe down
          if (
            typeof handleSwipeDown === 'function' &&
            (carouselName === 'Trending' ||
              (carouselName === 'Featured' && topNews?.length > 0) ||
              carouselName === 'Twinwin')
          ) {
            handleSwipeDown();
          }
        } else {
          // Swipe up
          if (typeof handleSwipeUp === 'function') {
            handleSwipeUp();
          }
        }
        setTouchStartX(null); // Reset touch start position
        setTouchStartY(null); // Reset touch start position
      }
    }
  };

  const handleNavigateBack = () => {
    setCurrentIndex(0);
    if (typeof handleSwipeUp === 'function') {
      handleSwipeUp(); // Trigger the swipe-up action
    }
  };

  useEffect(() => {
    // Skip setting up the timer for "Birthdays" carousel
    if (carouselName === 'Birthdays' || carouselName === 'Anniversaries' || carouselName === 'Joinees' || carouselName === 'GPL') return;

    if (carouselName === 'Featured' || carouselName === 'Trending' || carouselName === 'Twinwin') {
    } else {
      setCurrentIndex(4);
    }

    // console.log('current index', currentIndex, progressValues);
    if (currentIndex >= progressValues.length) return;

    // const progressDuration = (storyLength + 1) * 1000; // 5 seconds
    const progressDuration = 5000; // 5 seconds
    // const progressDuration = (dataLength + 1) * 1000; // 5 seconds
    const progressStep = 100 / (progressDuration / 100); // Calculate the step increment

    const timer = setInterval(() => {
      if (!isPaused && !dialogOpen) {
        // Only update progress if not paused
        setProgressValues((prevValues) => {
          const newValues = [...prevValues];
          newValues[currentIndex] += progressStep;
          if (newValues[currentIndex] >= 100) {
            clearInterval(timer);
            // setCurrentIndex(1);
            handleTapRight();
            setSwipeDirection('right');

            if (carouselName === 'Featured' || carouselName === 'Trending' || carouselName === 'Twinwin') {
              if (carouselName === 'Twinwin' && currentIndex === dataLength) {
                handleSwipeUp();
              }
              console.log('single story ended');
              // setCurrentIndex((prevIndex) => Math.min(prevIndex + 1, progressValues.length - 1));
            }
          }

          let finalValues = newValues.map((val, i) => {
            if (i > currentIndex) {
              return 0;
            }
            return val;
          });
          return finalValues;
        });
      }
    }, 100); // Update progress every 100ms

    return () => {
      clearInterval(timer);
    };
  }, [currentIndex, isPaused, carouselName, progressValues, dialogOpen]);

  const handleTapRight = () => {
    setProgressValues((prevValues) => {
      const newValues = [...prevValues];
      newValues[currentIndex] = 100; // Complete current index progress
      return newValues;
    });
    setCurrentIndex((prevIndex) => Math.min(prevIndex + 1, dataLength));
    if (currentIndex === dataLength) {
      handleSwipeRight();
    }
    // setActiveProgressIndex((prevIndex) => Math.min(prevIndex + 1, progressValues.length - 1));
  };

  const handleTapLeft = () => {
    setProgressValues((prevValues) => {
      // newValues[currentIndex] = 0; // Reset current index progress
      let finalValues = prevValues.map((val, i) => {
        if (i >= currentIndex - 1) {
          return 0;
        }
        return 100;
      });
      return finalValues;
    });
    setCurrentIndex((prevIndex) => Math.max(prevIndex - 1, 0));
    if (currentIndex === 0) {
      handleSwipeLeft();
    }
    // setActiveProgressIndex((prevIndex) => Math.max(prevIndex - 1, 0));
  };

  const handleSwipeDown = (id) => {
    let selectedNewsId;

      if (carouselName === 'Twinwin' && currentIndex===0) {
        return
      }

    if (carouselName === 'Featured') {
      selectedNewsId = topNews[currentIndex]._id;
      // navigate('/home/announcement/gnnDetails/' + selectedNewsId);
    } else if (carouselName === 'Trending') {
      selectedNewsId = trendingNews[currentIndex]._id;
      // navigate('/home/announcement/gnnDetails/' + selectedNewsId);
    }

    setSelectedNewsId(selectedNewsId);
    setDialogOpen(true);
    console.log('open story');
  };

  const handleCloseDialog = () => {
    console.log('close story');
    setDialogOpen(false);
  };

  // console.log(topNews, 'topnews');
  // console.log(children, 'topNews');
  return (
    <>
      {isLoading ? (
        <p>Loading</p>
      ) : isSm ? (
        <>
          <Dialog
            fullScreen
            open={true}
            sx={{ backgroundColor: 'lightgrey' }}
            onTouchEnd={handleTouchEnd} // Add onTouchEnd to handle resume
            // onClick={(e) => {
            //   if (carouselName === 'Featured' || carouselName === 'Trending' || carouselName === 'Openings') {
            //     // Get the position of the click within the dialog
            //     const screenWidth = window.innerWidth;
            //     if (e.clientX > screenWidth / 2) {
            //       handleTapRight(); // Tap right side
            //     } else {
            //       handleTapLeft(); // Tap left side
            //     }
            //   }
            // }}
          >
            <Box sx={{ backgroundColor: 'black', height: 4 }}></Box>
            {carouselName === 'Featured' || carouselName === 'Trending' || carouselName === 'Twinwin' ? (
              <Box
                sx={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  backgroundColor: 'black',
                }}
              >
                {Array.from({ length: dataLength + 1 }).map((_, index) => (
                  <React.Fragment key={index}>
                    <LinearProgress
                      variant="determinate"
                      value={progressValues[index]}
                      sx={{
                        width: `${(100 - 2 * (dataLength + 1)) / (dataLength + 1)}%`, // Adjust width as needed
                        height: 2,
                        backgroundColor: index < currentIndex ? 'white' : 'grey',
                        '& .MuiLinearProgress-bar': {
                          backgroundColor: 'white',
                        },
                      }}
                    />
                    {index < dataLength && (
                      <Box
                        sx={{
                          width: '2%', // Adjust width to control space size
                          height: 2,
                          backgroundColor: 'black',
                        }}
                      />
                    )}
                  </React.Fragment>
                ))}
              </Box>
            ) : (
              Array.from({ length: dataLength + 1 }).map((_, index) => (
                <React.Fragment key={index}>
                  {index === dataLength && (
                    <LinearProgress
                      variant="determinate"
                      value={progressValues[dataLength]}
                      sx={{
                        width: '100%', // Adjust width as needed
                        height: 2,
                        backgroundColor: 'grey',
                        '& .MuiLinearProgress-bar': {
                          backgroundColor: 'white',
                        },
                      }}
                    />
                  )}
                </React.Fragment>
              ))
            )}
            <DialogTitle sx={{ paddingLeft: 0.3, backgroundColor: 'black', color: 'white' }}>
              <Grid sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                <IconButton
                  className="backButton"
                  onClick={handleNavigateBack}
                  sx={{
                    p: 0,
                    pl: 1,
                    pr: 1.2,
                    display: 'flex',
                  }}
                >
                  <ArrowBack fontSize="small" sx={{ fontSize: '23px', color: 'white' }} />
                </IconButton>
                <Box sx={{ mr: 1 }}>{carouselIcon}</Box>
                <Typography sx={{ fontSize: '18px' }}>{carouselName}</Typography>
              </Grid>
            </DialogTitle>
            <Grid
              ref={containerRef}
              sx={{
                display: 'flex',
                flexDirection: 'row',
                overflowX: 'hidden',
                width: '100%',
                scrollBehavior: 'smooth',
                touchAction: 'none', // Prevent default touch actions (like scrolling)
              }}
              onTouchStart={handleTouchStart}
              onTouchMove={handleTouchMove}
              onClick={(e) => {
                if (carouselName === 'Featured' || carouselName === 'Trending' || carouselName === 'Twinwin') {
                  // Get the position of the click within the dialog
                  const screenWidth = window.innerWidth;
                  if (e.clientX > screenWidth / 2) {
                    handleTapRight(); // Tap right side
                  } else {
                    handleTapLeft(); // Tap left side
                  }
                }
              }}
            >
              {children}
            </Grid>
          </Dialog>
          <CustomDialogBox
            open={dialogOpen}
            handleClose={handleCloseDialog}
            // title="News Details"
            content={
              <>
                <Grid
                  item
                  xs={12}
                  lg={9.5}
                  container
                  sx={{
                    flex: 1,
                    p: 1,
                    pl: 0,
                    display: 'grid',
                    gridTemplateRows: '70px 1fr',
                    height: '100%',
                    width: '100%',
                    overflow: 'hidden',
                    [theme.breakpoints.down('lg')]: {
                      display: 'grid',
                      p: 0,
                    },
                  }}
                >
                  {carouselName == 'Twinwin' ? (
                    <ReferralForm handleNavigateBack={handleCloseDialog} jobId={iterableData ? iterableData[currentIndex]?.id : null} />
                  ) : (
                    <>
                      <NewsDetailsNavbar handleNavigate={handleCloseDialog} />
                      <NewsComments Id={selectedNewsId} />
                    </>
                  )}
                </Grid>
              </>
            } // Pass the selected news ID to NewsComments
            width="100%"
            height="100%"
            fullScreen={false}
            margin={0}
            padding={0.4}
            shouldAnimate={true}
          />
        </>
      ) : (
        // <Dialog
        //   open={true}
        //   onTouchEnd={handleTouchEnd}
        //   container={() => document.getElementById('dialog-container')}
        //   keepMounted
        //   PaperProps={{
        //     sx: {
        //       width: '30%',
        //       height: '100%',
        //       maxWidth: 'none',
        //       backgroundColor: 'lightgrey',
        //       display: 'flex',
        //       flexDirection: 'column',
        //     },
        //   }}
        // >
        <>
          <Box sx={{ backgroundColor: 'black', height: 4 }}></Box>

          {carouselName === 'Featured' || carouselName === 'Trending' || carouselName === 'Twinwin' ? (
            <Box
              sx={{
                width: '100%',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                backgroundColor: 'black',
              }}
            >
              {Array.from({ length: dataLength + 1 }).map((_, index) => (
                <React.Fragment key={index}>
                  <LinearProgress
                    variant="determinate"
                    value={progressValues[index]}
                    sx={{
                      width: `${(100 - 2 * (dataLength + 1)) / (dataLength + 1)}%`,
                      height: 2,
                      backgroundColor: index < currentIndex ? 'white' : 'grey',
                      '& .MuiLinearProgress-bar': {
                        backgroundColor: 'white',
                      },
                    }}
                  />
                  {index < dataLength && (
                    <Box
                      sx={{
                        width: '2%',
                        height: 2,
                        backgroundColor: 'black',
                      }}
                    />
                  )}
                </React.Fragment>
              ))}
            </Box>
          ) : (
            Array.from({ length: dataLength + 1 }).map((_, index) => (
              <React.Fragment key={index}>
                {index === dataLength && (
                  <LinearProgress
                    variant="determinate"
                    value={progressValues[dataLength]}
                    sx={{
                      width: '100%',
                      height: 2,
                      backgroundColor: 'grey',
                      '& .MuiLinearProgress-bar': {
                        backgroundColor: 'white',
                      },
                    }}
                  />
                )}
              </React.Fragment>
            ))
          )}

          <DialogTitle sx={{ paddingLeft: 0.3, backgroundColor: 'black', color: 'white' }}>
            <Grid sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
              <IconButton
                className="backButton"
                onClick={handleNavigateBack}
                sx={{ p: 0, pl: 1, pr: 1.2, display: 'flex' }}
              >
                <ArrowBack fontSize="small" sx={{ fontSize: '23px', color: 'white' }} />
              </IconButton>
              <Box sx={{ mr: 1 }}>{carouselIcon}</Box>
              <Typography sx={{ fontSize: '18px' }}>{carouselName}</Typography>
            </Grid>
          </DialogTitle>

          <Grid
            ref={containerRef}
            sx={{
              display: 'flex',
              flexDirection: 'row',
              overflowX: 'hidden',
              width: '100%',
              scrollBehavior: 'smooth',
              touchAction: 'none',
              flex: 1,
            }}
            onTouchStart={handleTouchStart}
            onTouchMove={handleTouchMove}
            onClick={(e) => {
              if (carouselName === 'Featured' || carouselName === 'Trending' || carouselName === 'Twinwin') {
                const screenWidth = window.innerWidth;
                if (e.clientX > screenWidth / 2 && !isTwinWinFormOpen) {
                  handleTapRight();
                } else {
                  handleTapLeft();
                }
              }
            }}
          >
            {children}
          </Grid>
        </>
        // {/* </Dialog> */}
      )}
    </>
  );
}

export default SwipeableGrid;
